import { creatUUId } from './CreateUUID';

export const awsRegion = process.env.REACT_APP_AWS_REGION;
export const s3Bucket = process.env.REACT_APP_S3_BUCKET;
export const accessKeyId = process.env.REACT_APP_ACCESS_KEY_ID;
export const secreteAccessKey = process.env.REACT_APP_SECRETE_ACCESS_KEY;
export const Uploadconfig = {
    bucketName: s3Bucket,
    region: awsRegion,
    accessKeyId,
    dirName: `eub/${creatUUId()}`,
    secretAccessKey: secreteAccessKey,
};
export const Bannerconfig = {
    bucketName: s3Bucket,
    region: awsRegion,
    accessKeyId,
    dirName: `banner/${creatUUId()}`,
    secretAccessKey: secreteAccessKey,
};
export const Invoiceconfig = {
    bucketName: s3Bucket,
    region: awsRegion,
    accessKeyId,
    dirName: `invoice/${creatUUId()}`,
    secretAccessKey: secreteAccessKey,
};
